import moment from "moment";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const SalesPerformanceChart = ({ performanceData }) => {
    const [options, setOptions] = useState({
        chart: {
            type: 'area',
            height: 350,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 1,
            colors: ['#EC8EBB']
        },
        colors: ['#EC8EBB'],
        xaxis: {
            categories: [],
            labels: {
                style: {
                    colors: '#EC8EBB',
                    fontSize: '12px',
                    fontFamily: 'DM Sans'
                }
            },
            axisBorder: {
                show: true,
                color: '#040303',
            },
            axisTicks: {
                show: true,
                color: '#040303',
            }
        },
        yaxis: {
            // min: 0,
            // max: 100,
            tickAmount: 5,
            labels: {
                style: {
                    colors: '#7D7D7D',
                    fontSize: '12px',
                    fontFamily: 'DM Sans'
                }
            },
        },
        grid: {
            borderColor: '#E9E9E9',
            strokeDashArray: 0,
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "RM" + val 
                }
            }
        },
        legend: {
            show: false
        },
        noData: {
            text: "No Data",
            align: 'center',
            verticalAlign: 'middle',
            style: { fontSize: '14px' }
        },
    });
    const [series, setSeries] = useState([
        {
            name: 'Sales',
            data: []
        }
    ]);

    useEffect(() => {
        if(performanceData?.length >= 0){
            setSeries([
                {
                    name: 'Sales',
                    data: performanceData?.map(item => item.sales) || []
                }
            ])
            setOptions(prev => ({
                ...prev,
                xaxis: {
                    ...prev.xaxis,
                    categories: performanceData?.map(item => `${moment(item.month, "M").format("MMM")} ${item.year}`) || [],
                }
            }))
        }
    }, [performanceData])
    return (
        <div id="line-column-chart" className="apex-charts" dir="ltr">
            <ReactApexChart options={options} series={series} type="area" height={350} />
        </div>
    )
}
export default SalesPerformanceChart;